import { AimOutlined, ClockCircleOutlined } from "@ant-design/icons";
import React, { useState } from "react";

import "./stylesScheduleDelivery.css";
import { Checkbox, Select } from "antd";
import { AppStrings } from "../../../../utils/constants/AppStrings";
function ScheduleDelivery() {
  const [activeScheduler, setActiveScheduler] = useState(0);
  const [activeSchedulingOption, setActiveSchedulingOption] = useState(0);

  return (
    <div className="schedule-delivery-container">
      <div className="schedule-delivery-header">
        <h2>{AppStrings.DELIVERY}</h2>
        <p>{AppStrings.CHOOSE_TYPE}:</p>
        <div className="schedule-delivery-types">
          <div
            className={`schedule-delivery-type ${
              activeScheduler === 0 ? "active" : ""
            }`}
            onClick={() => setActiveScheduler(0)}
          >
            <div className="schedule-delivery-type-header">
              <div className="clock-icon-container">
                <AimOutlined className="schedule-delivery-icon" />
              </div>
              <div className="circle">
                <div className="inner-circle"></div>
              </div>
            </div>
            <h3>{AppStrings.SCHEDULED}</h3>
            <p>
              {AppStrings.ENTER_PLAYERS_AT} <br />
              {AppStrings.DESIGNATED_TIMES}
            </p>
          </div>
          <div
            className={`schedule-delivery-type ${
              activeScheduler === 1 ? "active" : ""
            }`}
            onClick={() => setActiveScheduler(1)}
          >
            <div className="schedule-delivery-type-header">
              <div className="clock-icon-container">
                <ClockCircleOutlined className="schedule-delivery-icon" />
              </div>
              <div className="circle">
                <div className="inner-circle"></div>
              </div>
            </div>
            <h3>{AppStrings.ACTION_BASED}</h3>
            <p>
              {AppStrings.ENTER_PLAYER_WHEN_THEY} <br /> {AppStrings.PERFORM_ACTIONS}
            </p>
          </div>
        </div>
      </div>
      <div className="scheduling-options-container">
        <h3>{AppStrings.TIME_BASED_SCHEDULING_OPTIONS}</h3>
        <div className={`scheduling-options`}>
          <div
            className={`scheduling-option-1 ${
              activeSchedulingOption === 0 ? "active" : ""
            }`}
          >
            <div
              className="circle"
              onClick={() => setActiveSchedulingOption(0)}
            >
              <div className="inner-circle"></div>
            </div>
            <span>{AppStrings.SEND_AS_SOON_AS_PROMO_IS_LAUNCHED}</span>
          </div>
          <div
            className={`scheduling-option-2 ${
              activeSchedulingOption === 1 ? "active" : ""
            }`}
          >
            <div
              className="circle"
              onClick={() => setActiveSchedulingOption(1)}
            >
              <div className="inner-circle"></div>
            </div>
            <div>
              <span>{AppStrings.SEND_AT_A_DESIGNATED_TIME}</span>
              <p>{AppStrings.CHOOSE_A_TIME_FOR_PLAYERS_TO_RECEIVE_THIS_MESSAGE}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="how-often-container">
        <p>{AppStrings.HOW_OFTEN_TO_SEND}</p>
        <div className="how-often-options">
          <Select
            placeholder={AppStrings.PAM_NEW_PROMOTION_SELECT_FREQUENCY}
            options={[
              { value: "Once", label: AppStrings.PAM_NEW_PROMOTION_FREQ_ONCE },
              { value: "Daily", label: AppStrings.PAM_NEW_PROMOTION_FREQ_DAILY },
              { value: "Weekly", label: AppStrings.PAM_NEW_PROMOTION_FREQ_WEEKLY },
              { value: "Monthly", label: AppStrings.PAM_NEW_PROMOTION_FREQ_MONTHLY },
            ]}
          />
          <div className="checkbox-container">
            <Checkbox defaultChecked={false} onChange={() => {}} />
            <span>{AppStrings.SEND_PROMO_TO_PLAYERS_IN_THEIR_LOCAL_TIME_ZONE}</span>
          </div>
        </div>
        <div className="next-send-time">
          <div className="left-content">
            <ClockCircleOutlined className="schedule-delivery-icon" />
            <span>{AppStrings.NEXT_SEND_TIME}:</span>
          </div>
          <span className="next-send-time-text">
            {AppStrings.NO_UPCOMING_MESSAGES_SCHEDULED}
          </span>
        </div>
        <div className="delivery-controls">
          <h3>{AppStrings.DELIVERY_CONTROLS}</h3>
          <div className="delivery-controls-options">
            <p>{AppStrings.MANAGE_THE_NUMBER_OF_MESSAGES_YOUR_PLAYERS_WILL_RECEIVE}</p>
            <div className="checkbox-container">
              <Checkbox defaultChecked={false} onChange={() => {}} />
              <span>{AppStrings.ALLOW_PLAYERS_TO_BECOME_RE_ELIGIBLE_TO_RECEIVE_PROMO}</span>
            </div>
          </div>
          <p className="frequency-capping">{AppStrings.FREQUENCY_CAPPING}</p>
          <p className="frequency-capping-text">
            {AppStrings.YOU_HAVE_NOT_CREATED_ANY_FREQUENCY_CAPPING_RULES} {" "}
            <span>{AppStrings.MANAGE_FREQUENCY_CAPPING_RULES}</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ScheduleDelivery;
